<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <div class="search-bar">
          <el-select v-model="searchParam.cat_uuid" clearable placeholder="请选择分类" @clear="getList">
            <el-option v-for="(item, index) in classList" :key="index" :label="item.title" :value="item.uuid">
            </el-option>
          </el-select>
          <el-input
            v-model="searchParam.keyword_search"
            suffix-icon="el-icon-search"
            placeholder="输入关键字"
            clearable
            @clear="getList"
          ></el-input>
          <el-button type="primary" @click="searchList">搜索</el-button>
          <!--<el-button>重置</el-button>-->
        </div>
      </div>
      <div class="right">
        <el-button type="primary" size="small" @click="addItem"> 新建 </el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="cat_uuid" label="所属分类" align="center">
          <template slot-scope="scope">
            <span>{{ getCateName(scope.row.cat_uuid) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pv" label="浏览数量" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pv || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>

        <el-table-column label="操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button v-if="scope.row.is_top === 2" class="mid-blue" @click="cancelTop(scope.row)">取消置顶</el-button>
            <el-button v-else class="mid-blue" @click="toTop(scope.row)">置顶</el-button>
            <el-button class="mid-blue" @click="editItem(scope.row)">编辑</el-button>
            <el-button class="mid-blue" @click="xiajia(scope.row)">{{
              scope.row.status == 2 ? "下架" : "上架"
            }}</el-button>
            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.page_index"
          :limit.sync="listQuery.page_size"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getStyle, ArticleTop, getCate, ArticleStatus, delArticle } from "@/api/operation.js";
export default {
  components: { Pagination },
  data() {
    return {
      total: 10,
      classList: [
        {
          id: 1,
          name: "护理员工作规章制度",
        },
      ],
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      searchParam: {},
      tableData: [],
    };
  },
  mounted() {
    this.getList();
    this.getClassList();
  },
  methods: {
    getCateName(id) {
      const item = this.classList.find((ite) => {
        return ite.uuid == id;
      });
      if (!item) {
        return "";
      }
      return item.title;
    },
    async getClassList() {
      const res = await getCate({ status: 2 });
      if (res.data instanceof Array) {
        this.classList = res.data;
      }
    },
    editItem(row) {
      this.$router.push({
        path: "/add-school-style",
        query: row,
      });
    },
    async setTop(row) {
      const res = await ArticleTop(row.uuid);
      if (res) {
        this.$message.success("成功");
        this.getList();
      }
    },
    cancelTop(row) {
      this.$confirm("确定要取消置顶吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO : 学校风采取消置顶接口对接
          this.setTop(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作已取消",
          });
        });
    },
    toTop(row) {
      this.$confirm("确定要置顶吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO : 学校风采置顶接口对接
          this.setTop(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "操作已取消",
          });
        });
    },
    xiajia(row) {
      this.$confirm("确定要" + (row.status == 2 ? "下架" : "上架") + "吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO : 学校风采下架接口对接
          ArticleStatus(row.uuid).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下架",
          });
        });
    },
    deleteItem(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO : 学校风采删除接口对接
          delArticle(row.uuid).then((res) => {
            if (res == true) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    searchList() {
      this.listQuery.page_index = 1;
      this.getList();
    },
    async getList() {
      const res = await getStyle({
        type: 1,
        ...this.searchParam,
        ...this.listQuery,
      });
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
      // TODO : 学校风采列表接口对接
    },
    addItem() {
      this.$router.push({
        path: "/add-school-style",
      });
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
